
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/solar-design",
      function () {
        return require("private-next-pages/integrations/solar-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/solar-design"])
      });
    }
  